(() => {
  const root = window.Shopify?.routes?.root || '/';
  const kit = document.querySelector('[data-ps-kit]');
  const button = kit?.querySelector('[data-ps-add-kit]');
  if (button && kit.dataset.tubVariant && kit.dataset.chillerVariant) {
    button.disabled = false;
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    kit.append(status);
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      button.textContent = 'Adding to your bag…';
      status.textContent = '';
      try {
        const result = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(kit.dataset.tubVariant), quantity: 1 },
            { id: Number(kit.dataset.chillerVariant), quantity: 1 }
          ] })
        });
        const data = await result.json();
        if (!result.ok) throw new Error(data.description || 'We could not add both items. Please check availability with our team.');
        if (!Array.isArray(data.items) || data.items.length !== 2) throw new Error('Please check your bag before trying again.');
        window.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message || 'The connection was interrupted. Please check your bag before trying again.';
        button.textContent = 'Check your bag before trying again';
        const bagLink = document.createElement('a');
        bagLink.href = root + 'cart';
        bagLink.textContent = 'Open your bag →';
        bagLink.className = 'ps-button ps-button--line';
        status.append(' ', bagLink);
      }
    });
  }
  const mobile = document.querySelector('.ps-mobile-nav');
  mobile?.addEventListener('click', event => {
    if (event.target.closest('a')) mobile.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ps-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  const interest = document.querySelector('[name="contact[product_interest]"]');
  const query = new URLSearchParams(location.search).get('product');
  if (query && interest) {
    const names = {'starter-set':'Starter Set','performance-set':'Performance Set','luxury-set':'Luxury Set'};
    const value = names[query] || (/^(yg|rll|sy-)/.test(query) ? 'Cold' : query.startsWith('sn-') ? 'Heat' : query.startsWith('rl') ? 'Light' : 'General');
    interest.value = value;
  }
})();
